/* eslint-disable webflow/no-delete */

import type {Context} from '../types';

const CONDITION_INVISIBLE_CLASS = 'w-condition-invisible';

const skuPriceFieldPath = 'sku:price';
const orderItemPriceFieldPath = 'price';

export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {jsonNodes},
    // eslint-disable-next-line webflow/deprecated
    fn: {__DEPRECATED__scanSubtree},
  } = context;
  const {data = {}} = jsonNode;

  function isAncestorOfProcessedNode(parentCandidateNode: any) {
    let isAncestorOfNode = false;

    __DEPRECATED__scanSubtree(parentCandidateNode, (childNode) => {
      if (childNode === jsonNode) {
        isAncestorOfNode = true;
      }
    });
    return isAncestorOfNode;
  }

  const conditionFields =
    data.dyn &&
    data.dyn.condition &&
    data.dyn.condition.class &&
    data.dyn.condition.class.false &&
    data.dyn.condition.class.false[CONDITION_INVISIBLE_CLASS] &&
    data.dyn.condition.class.false[CONDITION_INVISIBLE_CLASS].fields;

  const hasSkuPriceCondition = Boolean(
    conditionFields &&
    typeof conditionFields === 'object' &&
    conditionFields[skuPriceFieldPath] &&
    typeof conditionFields[skuPriceFieldPath] === 'object'
  );

  let needsMigration = false;

  // if jsonNode has conditional visibility configured on sku:price field path
  if (hasSkuPriceCondition) {
    const orderItemNodes = jsonNodes.filter(isCommerceOrderItemListItem);

    // and jsonNode is within the subtree of an Order Items List Item node
    // (i.e. it's within the Order Items binding context)
    if (orderItemNodes.length > 0) {
      for (let index = 0; index < orderItemNodes.length; index++) {
        const orderItemNode = orderItemNodes[index];
        const containsProcessedNode = isAncestorOfProcessedNode(orderItemNode);

        if (containsProcessedNode) {
          // then we need to migrate this node
          needsMigration = true;
          break;
        }
      }
    }
  }

  return {
    needed: needsMigration,
    logData: {
      msg: 'Migrate order item price condition from field path "sku:price" to "price".',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const skuPriceCondition = conditionFields[skuPriceFieldPath];
      // copy condition from sku:price field path to price field path
      conditionFields[orderItemPriceFieldPath] = skuPriceCondition;
      // delete condition on sku:price field path
      delete conditionFields[skuPriceFieldPath];
    },
  };
};

function isCommerceOrderItemListItem(node: any) {
  return (
    node.type === 'CommerceCartItem' ||
    node.type === 'CommerceCheckoutOrderItem'
  );
}
